import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { PromotionListResponse } from "../models/response/PromotionListResponse";

export const promotionApi = {
    getPromotions: async (): Promise<
        UnifiedResponse<PromotionListResponse>
    > => {
        const response = await apiClient.post<
            UnifiedResponse<PromotionListResponse>
        >(
            "/promotion/users/retrieve/list",
            {
                pageNo: 0,
                pageSize: 20,
            },
            {
                headers: {
                    requiresAuth: false,
                },
            }
        );

        return response.data;
    },

    getPromotionByPageUrl: async (
        pageUrl: string
    ): Promise<UnifiedResponse<PromotionListResponse>> => {
        const response = await apiClient.post<
            UnifiedResponse<PromotionListResponse>
        >(
            "/promotion/retrieve_by_page_url",
            {
                pageurl: pageUrl,
            },
            {
                headers: {
                    requiresAuth: false,
                },
            }
        );

        return response.data;
    },
};

export default promotionApi;
